// Externe Bibliotheken
import React, { Component } from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertPrice } from '@/_helper/mapper';
import { checkAccess } from '../_helper/checkAccess';
import { chipClass } from '../_helper/mapper';
import tracking from '@/_helper/tracking';
import { withRouter } from '@/_helper/withRouter';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import HeroTeaser from '@/comp/heroTeaser';
import TravelFactsFull from '../_comp/travelFactsFull';
import ExcursionSlider from '../_comp/slider/slider';
import Button from '@/comp/button/button';
import AddParticipants from './addParticipants/AddParticipants';

// Styles
import './excursion-details.scss';

class ExcursionDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            excursionCode: props.params.id !== null ? props.params.id : null,
            galleryImages: [],
            fullDescription: false,
            activeAddParticipants: false,
            lightbox: false,
        };

        this.nextStepPlaceholder = React.createRef();

        this.getExcursion = this.getExcursion.bind(this);
        this.handleShowAddParticipants = this.handleShowAddParticipants.bind(this);
        this.handleScroll_callAction = this.handleScroll_callAction.bind(this);
    }

    getExcursion() {
        const { excursionCode } = this.state;

        let offers = storage.get('excursionOffers');

        // check images
        function setImages(images, t) {
            // sizes | original , display , thumbnail
            let imagesSize = [];
            const checkImage = (item) =>
                new Promise((resolve) => {
                    let i = new Image();
                    i.src = item.replace(/original/gi, 'display');
                    i.onerror = function () {
                        resolve({ status: 'error', item });
                    };
                    i.onload = function () {
                        if (this.naturalHeight > 0 && this.naturalWidth > 0) {
                            imagesSize.push(item.replace(/original/gi, 'display'));
                            resolve({ status: 'ok', item });
                        }
                    };
                });

            Promise.all(images.map(checkImage)).then((value) => {
                t.setState({
                    galleryImages: imagesSize,
                });
            });
        }

        if (offers !== null) {
            let ex = _.filter(offers.data?.excursionOffers, function (o) {
                return o.supplierOfferId === excursionCode;
            });

            if (ex[0] === undefined) {
                window.location.href = '#/ausfluege';
                window.location.reload();
            }

            this.setState({
                excursion: ex[0],
            });

            // set images
            setImages(ex[0].images, this);

            // set document title
            document.title = ex[0].title + ' | Ausflüge' + window.$documentTitle;

            return false;
        } else {
            window.location.href = '#/ausfluege';
            window.location.reload();
        }
    }

    componentDidMount() {
        document.title = 'Ausflüge' + window.$documentTitle;

        document.querySelector('html').classList.add('redesign');

        // not allowed
        checkAccess('allowExtraServicesExcursion');
        if (this.state.excursionCode === null) {
            window.location.href = '#/';
        }

        this.getExcursion();

        tracking('interaction', 'excursion');
        // window.addEventListener('scroll', this.handleScroll_callAction, true);
    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.handleScroll_callAction, true);
    }

    handleScroll_callAction(event) {
        const nextStepEl = document.querySelector('.next-step');
        const nextStepElPlaceholder = document.querySelector('.next-step-placeholder');
        const scrollTop = window.scrollY;
        if (scrollTop >= 460) {
            nextStepEl.classList.add('fix');
            nextStepElPlaceholder.classList.remove('show');
        } else {
            nextStepEl.classList.remove('fix');
            nextStepElPlaceholder.classList.add('show');
        }
    }

    handleShowAddParticipants(e) {
        if (e !== undefined) {
            this.setState({
                activeAddParticipants: e,
            });
        }
        return this.state.activeAddParticipants;
    }

    lightboxGallery() {
        let { galleryImages } = this.state;

        let SliderSettings = {
            dots: false,
            infinite: true,
            speed: 500,
            lazyLoad: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 3,
        };

        return (
            <div className={`lightbox ${this.state.lightbox ? 'show' : ''} `}>
                <div className="close" onClick={(e) => this.setState({ lightbox: false })}>
                    <i className="material-icons">close</i>
                </div>
                <div className="cnt">
                    <ExcursionSlider settings={SliderSettings} images={galleryImages} effect="" />
                </div>
            </div>
        );
    }

    the_gallery() {
        let { excursion, galleryImages } = this.state;

        if (excursion.images.length > 0) {
            // Config Excursion Slider
            let SliderSettings = {
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
            };

            let imagesSize = galleryImages;

            return (
                <div>
                    {imagesSize.length === 0 ? (
                        <div className="gallery">
                            <div className={'cover-container main'}>
                                <div className="image-sec">
                                    <span className="lazy-load-background"></span>
                                </div>
                                <div className="dots">
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot active"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </div>
                            </div>
                            {window.$browserInfo.device !== 'mobile' && (
                                <div className="sub">
                                    <div className="cover-container  width-1-1">
                                        <span className="lazy-load-background"></span>
                                    </div>
                                    <div className="cover-container  ">
                                        <span className="lazy-load-background"></span>
                                    </div>
                                    <div className="cover-container  ">
                                        <span className="lazy-load-background"></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <>
                            {this.lightboxGallery()}
                            <div className="gallery">
                                <div className={'cover-container main'}>
                                    <div className="image-sec">
                                        {window.$browserInfo.device === 'mobile' && (
                                            <div className="counter">
                                                {imagesSize.length} <i className="material-icons">photo_camera</i>
                                            </div>
                                        )}
                                        <ExcursionSlider settings={SliderSettings} images={imagesSize} />
                                    </div>
                                    <div className="dots">
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                        <span className="dot active"></span>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                    </div>
                                </div>

                                {window.$browserInfo.device !== 'mobile' && (
                                    <div className="sub">
                                        {imagesSize.map((value, index) => {
                                            if (index === 0 || index >= 4) {
                                                return false;
                                            }

                                            return (
                                                <div
                                                    className={`cover-container ${index === 1 ? 'width-1-1' : ''} `}
                                                    key={index}>
                                                    {imagesSize.length > 3 && index === 3 && (
                                                        <div
                                                            className="more-overlay"
                                                            onClick={(e) => this.setState({ lightbox: true })}>
                                                            + {imagesSize.length - 4} Bilder
                                                        </div>
                                                    )}
                                                    <LazyLoadImage
                                                        wrapperClassName="lazy-load-background"
                                                        src={value.replace(/original/gi, 'display')}
                                                        alt={excursion.title + 'Bild ' + index}
                                                        effect="blur"
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            );
        }
    }

    longDescription() {
        let { excursion } = this.state;

        if (excursion.longDescription !== undefined && excursion.longDescription.length > 0) {
            const length = 250;

            return (
                <div className="e long-description">
                    <article>
                        <h3 className="heading">Beschreibung</h3>

                        {excursion.longDescription.length <= length ? (
                            <div className="respect-new-line">{excursion.longDescription}</div>
                        ) : this.state.fullDescription ? (
                            <div className="respect-new-line">
                                {excursion.longDescription}{' '}
                                <span
                                    className="trigger color-primary"
                                    onClick={(e) => this.setState({ fullDescription: false })}>
                                    weniger lesen
                                </span>
                            </div>
                        ) : (
                            <div>
                                {excursion.longDescription.substring(0, length)} ...{' '}
                                <span
                                    className="trigger color-primary"
                                    onClick={(e) => this.setState({ fullDescription: !this.state.fullDescription })}>
                                    mehr lesen
                                </span>
                            </div>
                        )}
                    </article>
                </div>
            );
        }
    }

    inclusiveServices() {
        let { excursion } = this.state;

        if (
            (excursion.includedServices !== undefined && excursion.includedServices.length > 0) ||
            (excursion.notIncludedServices !== undefined && excursion.notIncludedServices.length > 0)
        ) {
            return (
                <div className="e inclusive-services">
                    <article>
                        <h3 className="heading">Inklusivleistungen</h3>

                        <div className="cnt">
                            {excursion.includedServices ? (
                                <>
                                    <div className="included-services">
                                        <ul className="hook-list">
                                            {excursion.includedServices.split(',').map((value, index) => {
                                                return (
                                                    <li className="seg" key={index}>
                                                        {value}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>

                                    {excursion.notIncludedServices && (
                                        <div className="not-included-services">
                                            <h4>Nicht im Preis inkludiert:</h4>
                                            <ul>
                                                {excursion.notIncludedServices.split(',').map((value, index) => {
                                                    return (
                                                        <li className="seg" key={index}>
                                                            {value}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="included-services">
                                    Bitte beachten Sie für die Inklusivleistungen den Beschreibungstext.
                                </div>
                            )}
                        </div>
                    </article>
                </div>
            );
        }
    }

    hygiene() {
        let { excursion } = this.state;

        if (excursion.hygiene !== undefined && excursion.hygiene.length > 0) {
            return (
                <div className="e">
                    <article>
                        <h3 className="heading">Hygiene</h3>
                        <ul className="hook-list">
                            <li>
                                Einhaltung von hohen Hygienemaßnahmen und geschultem Personal.
                                <br />
                                Bitte denken Sie an das Mitbringen von geeigneten Schutzmaßnahmen wie zum Beispiel
                                Masken.
                            </li>
                        </ul>
                    </article>
                </div>
            );
        }
    }

    detailBox() {
        let { excursion } = this.state;

        let duration = excursion.duration;
        if (duration === '0') {
            duration = '';
        } else {
            duration = duration.replaceAll('PT', '');

            if (parseInt(duration.substring(0, duration.indexOf('H'))) === 1) {
                duration = duration.replaceAll('H', ' Stunde ');
            } else {
                duration = duration.replaceAll('H', ' Stunden ');
            }

            if (parseInt(duration.substring(0, duration.indexOf('M'))) === 1) {
                duration = duration.replaceAll('M', ' Minute ');
            } else {
                duration = duration.replaceAll('M', ' Minuten ');
            }
        }

        return (
            <div className="e detail-box">
                {excursion.target && (
                    <div className={'target'}>
                        <i className="material-icons">person</i>
                        <div className="cnt">
                            <strong>Alterseignung</strong>
                            <small>{excursion.target}</small>
                        </div>
                    </div>
                )}

                {excursion.duration !== '0' && (
                    <div className={'duration'}>
                        <i className="material-icons">schedule</i>
                        <div className="cnt">
                            <strong>Dauer</strong>
                            <small dangerouslySetInnerHTML={{ __html: duration }}></small>
                        </div>
                    </div>
                )}

                {excursion.difficulty && (
                    <div className={'difficulty'}>
                        <i className="material-icons">height</i>
                        <div className="cnt">
                            <strong>Level</strong>
                            <small>{excursion.difficulty}</small>
                        </div>
                    </div>
                )}

                {excursion.needed && (
                    <div className={'needed'}>
                        <i className="material-icons">work</i>
                        <div className="cnt">
                            <strong>Ausrüstung</strong>
                            <small>{excursion.needed.replaceAll(',', ', ').replaceAll('/', '/ ')}</small>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    highlight() {
        let { excursion } = this.state;

        if (excursion.highlight !== undefined && excursion.highlight.length > 0) {
            return (
                <div className="e">
                    <article>
                        <h3 className="heading">Highlights</h3>
                        <p>{excursion.highlight}</p>
                    </article>
                </div>
            );
        }
    }

    render() {
        let { excursion } = this.state;

        if (excursion === undefined) {
            return false;
        }

        return (
            <div className="page-excursion-details">
                <Header />

                {window.$browserInfo.device === 'not-mobile' && <HeroTeaser size="full" />}

                <main className="content-wrapper">
                    <TravelFactsFull />

                    {/* Excursion */}
                    <section className="content">
                        <div className="head">
                            <h1 className="title">{excursion.title}</h1>

                            <div className="content">
                                <div className="details">
                                    <div className="location">
                                        <i className="large material-icons">place</i> {excursion.resort}
                                    </div>
                                    <div className="col">
                                        {excursion.distanceToAccommodation !== undefined &&
                                            excursion.distanceToAccommodation.toString().length > 0 && (
                                                <div className="distance-to-hotel-booked">
                                                    {excursion.distanceToAccommodation
                                                        .toFixed(1)
                                                        .toString()
                                                        .replace('.', ',')}{' '}
                                                    km vom Hotel entfernt
                                                </div>
                                            )}
                                        <div>
                                            <div className={'chip ' + chipClass(excursion.category)}>
                                                {excursion.category}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="information">
                                    <div className="total-price">
                                        <div>
                                            <span>ab</span> {excursion.price.pricePerPerson >= 0 ? '+' : '-'}{' '}
                                            {convertPrice(excursion.price.pricePerPerson, 0, 0)}
                                        </div>
                                        <div className="small-print">pro Person</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.the_gallery()}

                        <div className="details">
                            {/* col left */}
                            {(this.longDescription() || this.inclusiveServices() || this.hygiene()) && (
                                <div>
                                    {/* highlight mobile */}
                                    {window.$browserInfo.device === 'mobile' && this.highlight()}

                                    {this.longDescription()}

                                    {/* detailBox desktop */}
                                    {window.$browserInfo.device === 'mobile' && this.detailBox()}

                                    {this.inclusiveServices()}

                                    {this.hygiene()}
                                </div>
                            )}

                            {/* col right */}
                            <div className="col">
                                {/* highlight desktop */}
                                {window.$browserInfo.device === 'not-mobile' && this.highlight()}

                                {/* detailBox desktop */}
                                {window.$browserInfo.device === 'not-mobile' && this.detailBox()}

                                <div className="next-step-placeholder show" ref={this.nextStepPlaceholder}></div>
                                <div className="next-step">
                                    <AddParticipants
                                        supplierOfferId={excursion.supplierOfferId}
                                        handleShowAddParticipants={this.handleShowAddParticipants}
                                    />

                                    <div className="call-action">
                                        <div className="total-price">
                                            <div>
                                                <span>ab</span> {excursion.price.pricePerPerson >= 0 ? '+' : '-'}{' '}
                                                {convertPrice(excursion.price.pricePerPerson, 0, 0)}
                                            </div>
                                            <div className="small-print">pro Person</div>
                                        </div>

                                        <Button
                                            label="weiter"
                                            handleClick={(e) => {
                                                this.handleShowAddParticipants(true);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </div>
        );
    }
}

export default withRouter(ExcursionDetails);
